import React__default, { createContext, useContext, useRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { CODE_ESCAPE } from '../../../node_modules/keycode-js/dist/keycode.esm.js';

var SideNavigationKeyboardContext = createContext();
var useSideNavigationKeyboardContext = function useSideNavigationKeyboardContext() {
  return useContext(SideNavigationKeyboardContext);
};
var SideNavigationKeyboardProvider = function SideNavigationKeyboardProvider(_ref) {
  var _ref$sideNavigationRe = _ref.sideNavigationRef,
    sideNavigationRef = _ref$sideNavigationRe === void 0 ? undefined : _ref$sideNavigationRe,
    children = _ref.children;
  var menuItemRef = useRef(null);
  var setFocusRef = function setFocusRef(element) {
    menuItemRef.current = element;
  };
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(e) {
      if (e.key === CODE_ESCAPE) {
        var _menuItemRef$current;
        menuItemRef === null || menuItemRef === void 0 || (_menuItemRef$current = menuItemRef.current) === null || _menuItemRef$current === void 0 || _menuItemRef$current.focus();
      }
    };
    if (sideNavigationRef !== null && sideNavigationRef !== void 0 && sideNavigationRef.current) {
      sideNavigationRef.current.addEventListener('keydown', handleKeyDown);
    }
    return function () {
      if (sideNavigationRef !== null && sideNavigationRef !== void 0 && sideNavigationRef.current) {
        sideNavigationRef.current.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, [sideNavigationRef]);
  var value = useMemo(function () {
    return {
      menuItemRef: menuItemRef,
      setFocusRef: setFocusRef
    };
  }, [menuItemRef]);
  return React__default.createElement(SideNavigationKeyboardContext.Provider, {
    value: value
  }, children);
};
SideNavigationKeyboardProvider.propTypes = {
  children: PropTypes.node.isRequired,
  sideNavigationRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.any
  })])
};

export { SideNavigationKeyboardProvider, useSideNavigationKeyboardContext };
//# sourceMappingURL=SideNavigationKeyboardContext.js.map
